
import orgSelector from './org-selector';
var Plugin = {
    install: function install(Vue) {
        Vue.component('org-selector', orgSelector);
    }
};
export { orgSelector };
export default Plugin;


//////////////////
// WEBPACK FOOTER
// ./src/component/org-selector/index.js
// module id = 0
// module chunks = 0